import React, { useEffect, useState } from "react";
import NorthIcon from "@mui/icons-material/North";
import { Box } from "@mui/system";
import goToTopButtonStyle from "./style";

function GoToTop() {
  const classes = goToTopButtonStyle();
  const [isvisible, SetIsisVisible] = useState(false);
  console.log("dddddddddddddddddddddd", isvisible);

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, []);

  const listenToScroll = () => {
    let heightToHidden = 250;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHidden) {
      SetIsisVisible(true);
    } else {
      SetIsisVisible(false);
    }
  };

  const topScroll = () => {
    window.scrollTo({
      top: "0",
      left: "0",
      behavior: "smooth",
    });
  };

  return (
    <div>
      {isvisible && (
        <Box className={classes.topButton} onClick={topScroll}>
          <NorthIcon />
        </Box>
      )}
    </div>
  );
}

export default GoToTop;
